import { render } from "./MergeVendors.vue?vue&type=template&id=72ece501"
import script from "./MergeVendors.vue?vue&type=script&lang=js"
export * from "./MergeVendors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__